$("a.video").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    const classAttributes = `${video.attr('class') && `class="${video.attr('class')}"`}`;
    const dataAttributes = `${video.data('mfp-src') && `data-mfp-src="${video.data('mfp-src')}"`}`;
    const dataBsToggleAttribute = `${video.attr('data-bs-toggle') && `data-bs-toggle="${video.attr('data-bs-toggle')}"`}`;
    const dataBsTargetAttribute = `${video.attr('data-bs-target') && `data-bs-target="${video.attr('data-bs-target')}"`}`;
    // Apply attributes
    const buttonAttributes = `type="button" ${classAttributes} ${dataAttributes} ${dataBsToggleAttribute} ${dataBsTargetAttribute}`;

    // Construct and replace with button
    video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
});

$("a.video-mp4").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    const classAttributes = `${video.attr('class') && `class="${video.attr('class')}"`}`;
    const dataAttributesSrc = `${video.data('src') && `data-src="${video.data('src')}"`}`;
    const dataAttributesVTTSrc = `${video.data('vtt-src') && `data-vtt-src="${video.data('vtt-src')}"`}`;
    const dataAttributesVTTLabel = `${video.data('vtt-label') && `data-vtt-label="${video.data('vtt-label')}"`}`;
    const dataAttributesVTTSrcLang = `${video.data('vtt-srclang') && `data-vtt-srclang="${video.data('vtt-srclang')}"`}`;
    // Apply attributes
    const buttonAttributes = `${classAttributes} ${dataAttributesSrc} ${dataAttributesVTTSrc} ${dataAttributesVTTLabel} ${dataAttributesVTTSrcLang}`;

    // Construct and replace with button
    video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
});
